import React, { useState } from "react";
import PropTypes from "prop-types";
import CloseButton from "./CloseButton";
import axios from "axios";

const Toast = ({ id, message }) => {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  const markAsRead = async () => {
    try {
      const headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      await axios.get((`/api/v1/notifications/read?id=${id}`), { headers });
      setShow(false);
    } catch (error) {
      // handle error
    }
  };

  return (
    <div className="flex justify-end">
      <div
        className="max-w-xs bg-tggreen text-sm text-tgnavy rounded-md shadow-lg dark:bg-gray-900"
        role="alert"
      >
        <div className="flex p-4 items-center">
          <span className="flex-1">{message}</span>
          <span className="ml-3">
            <CloseButton onClick={(e) => markAsRead(e)} />
          </span>
        </div>
      </div>
    </div>
  );
};

Toast.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  message: PropTypes.string.isRequired,
}

export default Toast;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/notifications/toast/index.jsx